export * from './ProductDetailsIngredientsView';
